import APIService from "@/services/APIService.js"; 

export default {
  getAllSimulacoes(includeExpiredRecords) {
    return APIService.apiCall().get(`/simuladorBaixas/getAllSimulacoes/${includeExpiredRecords}`);
  },
  getSimulacao(id) {
    return APIService.apiCall().get(`/simuladorBaixas/getSimulacao/${id}`);
  },
  salvarSimulacao(postData, id) {
    return APIService.apiCall().post(`/simuladorBaixas/salvar/${id}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/simuladorBaixas/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/simuladorBaixas/executar/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/simuladorBaixas/duplicar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/simuladorBaixas/baixarPlanilha/${id}`, { responseType: "blob", ...config });
  },
  andamento(id) {
    return APIService.apiCall().get(`/simuladorBaixas/andamento/${id}`);
  },
  baixarArquivoModeloBaixas() {
    return APIService.apiCall().get(`/simuladorBaixas/baixarArquivoModeloBaixas/`, { responseType: "blob" });
  },
  baixarArquivoModeloAIS() {
    return APIService.apiCall().get(`/simuladorBaixas/baixarArquivoModeloAis`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
  baixarLogsTecnicos(id, config = {}) {
    return APIService.apiCall().get(`/simuladorBaixas/baixarLogsTecnicos/${id}`, { responseType: 'blob', ...config });
  },
};